import { useCallback, useMemo } from 'react';

import {
  buildAllFormValues,
  evaluateFieldVisibility,
} from 'helpers/candidate_application/form-page-helpers';
import { useSelector } from 'react-redux';

import { selectCandidateApplication } from 'api/candidate-application-slice';

const useVisibleSubsections = subsections => {
  const { candidateFields, application } = useSelector(selectCandidateApplication);
  const { fieldPathIndex } = candidateFields;
  const { id_uploads } = application || {};

  // Use shared helper to avoid divergence
  // Include id_uploads in dependencies so visibility updates when uploads change and requirements are recalculated
  // candidateFields includes idRequirementsMet which is recalculated when id_uploads change
  const allValues = useMemo(
    () =>
      buildAllFormValues({
        candidateFields,
        // no watchValues / currentPagePrefixes here
      }),
    [candidateFields, id_uploads],
  );

  const isFieldVisible = useCallback(
    field => evaluateFieldVisibility(field, allValues, fieldPathIndex),
    [allValues, fieldPathIndex],
  );

  const visibleSubsections = useMemo(() => {
    if (!Array.isArray(subsections) || subsections.length === 0) return [];

    return subsections.filter(subsection => {
      const fields = Array.isArray(subsection?.fields) ? subsection.fields : [];
      if (fields.length === 0) return false;

      return fields.some(isFieldVisible);
    });
  }, [subsections, isFieldVisible]);

  return visibleSubsections;
};

export default useVisibleSubsections;
